// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { MaterialAssemblyForm_AssemblyComponentFragmentDoc } from './components/material-assembly-form/MaterialAssemblyForm.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type MaterialCatalogListingsQueryVariables = Types.Exact<{
  filter: Types.MaterialListingsFilter;
  orderBy?: Types.InputMaybe<Types.MaterialListingOrderBy>;
  page?: Types.InputMaybe<Types.PageFilter>;
  includeDeleted: Types.Scalars['Boolean']['input'];
}>;


export type MaterialCatalogListingsQuery = { __typename?: 'Query', materialListings: { __typename?: 'MaterialListingsPage', entities: Array<{ __typename?: 'MaterialListing', id: string, name?: string | null | undefined, type: { __typename?: 'MaterialTypeDetail', code: Types.MaterialType }, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, name: string }, defaultVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, materialVariants: Array<{ __typename?: 'MaterialVariant', id: string, code: string, displayName: string, modelNumber?: string | null | undefined, deletedAt?: Types.Scalars['DateTime']['input'] | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, sortOrder: number, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined, swatchUrl?: string | null | undefined } | null | undefined } | null | undefined }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } } };

export type MaterialCatalog_MaterialListingCardFragment = { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, type: { __typename?: 'MaterialTypeDetail', code: Types.MaterialType }, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, name: string }, defaultVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, materialVariants: Array<{ __typename?: 'MaterialVariant', id: string, code: string, displayName: string, modelNumber?: string | null | undefined, deletedAt?: Types.Scalars['DateTime']['input'] | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, sortOrder: number, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined, swatchUrl?: string | null | undefined } | null | undefined } | null | undefined }> };

export type MaterialCatalog_MaterialListingCardVariantFragment = { __typename?: 'MaterialVariant', id: string, code: string, displayName: string, modelNumber?: string | null | undefined, deletedAt?: Types.Scalars['DateTime']['input'] | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, sortOrder: number, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined, swatchUrl?: string | null | undefined } | null | undefined } | null | undefined };

export type MaterialCatalogMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MaterialCatalogMetadataQuery = { __typename?: 'Query', materialBrands: Array<{ __typename?: 'MaterialBrand', id: string, name: string }>, items: Array<{ __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, isAdminManaged: boolean, useInTakeoff: boolean, sortOrder: number, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } | null | undefined, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, materialVariantTags: Array<{ __typename?: 'MaterialVariantTag', id: string, name: string }> };

export type SaveMaterialVariantMutationVariables = Types.Exact<{
  input: Types.SaveMaterialVariantInput;
}>;


export type SaveMaterialVariantMutation = { __typename?: 'Mutation', saveMaterialVariant: { __typename?: 'SaveMaterialVariantResult', materialVariant: { __typename?: 'MaterialVariant', id: string, code: string, displayName: string, codeOverride?: string | null | undefined, modelNumber?: string | null | undefined, deletedAt?: Types.Scalars['DateTime']['input'] | null | undefined, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, description?: string | null | undefined, manufacturerUrl?: string | null | undefined, type: { __typename?: 'MaterialTypeDetail', code: Types.MaterialType }, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, isAdminManaged: boolean, useInTakeoff: boolean, sortOrder: number, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } | null | undefined, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> } }, components: Array<{ __typename?: 'MaterialAssemblyComponent', id: string, name?: string | null | undefined, qualifier?: string | null | undefined, component: { __typename?: 'MaterialVariant', id: string, displayName: string, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, useInTakeoff: boolean } }>, listing: { __typename?: 'MaterialListing', id: string, type: { __typename?: 'MaterialTypeDetail', code: Types.MaterialType, name: string }, item: { __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, useInTakeoff: boolean, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> } } } }>, defaultBidItem: { __typename?: 'BidItem', id: string }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, sortOrder: number, asset?: { __typename?: 'Asset', id: string, version: string, url: string, fileName?: string | null | undefined, contentType: string, downloadUrl: string, attachmentUrl: string, previewUrl?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'] } | null | undefined } | null | undefined } } };

export type SaveMavMutationVariables = Types.Exact<{
  input: Types.SaveMaterialAttributeValueInput;
}>;


export type SaveMavMutation = { __typename?: 'Mutation', saveMaterialAttributeValue: { __typename?: 'SaveMaterialAttributeValueResult', materialAttributeValue: { __typename?: 'MaterialAttributeValue', id: string, textValue: string } } };

export type SaveMaterialBrandMutationVariables = Types.Exact<{
  input: Types.SaveMaterialBrandInput;
}>;


export type SaveMaterialBrandMutation = { __typename?: 'Mutation', saveMaterialBrand: { __typename?: 'SaveMaterialBrandResult', materialBrand: { __typename?: 'MaterialBrand', id: string, name: string } } };

export type MaterialCatalog_MaterialVariantFragment = { __typename?: 'MaterialVariant', id: string, code: string, displayName: string, codeOverride?: string | null | undefined, modelNumber?: string | null | undefined, deletedAt?: Types.Scalars['DateTime']['input'] | null | undefined, defaultBidItem: { __typename?: 'BidItem', id: string }, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, description?: string | null | undefined, manufacturerUrl?: string | null | undefined, type: { __typename?: 'MaterialTypeDetail', code: Types.MaterialType }, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, isAdminManaged: boolean, useInTakeoff: boolean, sortOrder: number, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } | null | undefined, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> } }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, sortOrder: number, asset?: { __typename?: 'Asset', id: string, version: string, url: string, fileName?: string | null | undefined, contentType: string, downloadUrl: string, attachmentUrl: string, previewUrl?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'] } | null | undefined } | null | undefined };

export type MaterialCatalog_MaterialListingFragment = { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, description?: string | null | undefined, manufacturerUrl?: string | null | undefined, type: { __typename?: 'MaterialTypeDetail', code: Types.MaterialType }, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, isAdminManaged: boolean, useInTakeoff: boolean, sortOrder: number, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } | null | undefined, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> } };

export type MaterialCatalog_ItemFragment = { __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, isAdminManaged: boolean, useInTakeoff: boolean, sortOrder: number, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } | null | undefined, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> };

export type MaterialCatalog_MaterialAttributeDimensionFragment = { __typename?: 'MaterialAttributeDimension', id: string, name: string, isAdminManaged: boolean, useInTakeoff: boolean, sortOrder: number, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } | null | undefined, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> };

export type MaterialCatalog_MaterialAttributeValueFragment = { __typename?: 'MaterialAttributeValue', id: string, textValue: string };

export type MaterialCatalog_MaterialBrandFragment = { __typename?: 'MaterialBrand', id: string, name: string };

export type MaterialCatalog_MaterialVariantImageFragment = { __typename?: 'MaterialVariantImage', id: string, sortOrder: number, asset?: { __typename?: 'Asset', id: string, version: string, url: string, fileName?: string | null | undefined, contentType: string, downloadUrl: string, attachmentUrl: string, previewUrl?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'] } | null | undefined };

export type MaterialCatalog_AssetFragment = { __typename?: 'Asset', id: string, version: string, url: string, fileName?: string | null | undefined, contentType: string, downloadUrl: string, attachmentUrl: string, previewUrl?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'] };

export const MaterialCatalog_MaterialBrandFragmentDoc = gql`
    fragment MaterialCatalog_MaterialBrand on MaterialBrand {
  id
  name
}
    `;
export const MaterialCatalog_MaterialListingCardVariantFragmentDoc = gql`
    fragment MaterialCatalog_MaterialListingCardVariant on MaterialVariant {
  id
  code
  displayName
  modelNumber
  deletedAt
  featuredImage {
    id
    sortOrder
    asset {
      id
      previewUrl(resizing: {width: 330, region: FULL})
      swatchUrl: previewUrl(resizing: {width: 64, region: SQUARE})
    }
  }
}
    `;
export const MaterialCatalog_MaterialListingCardFragmentDoc = gql`
    fragment MaterialCatalog_MaterialListingCard on MaterialListing {
  id
  name
  type {
    code
  }
  brand {
    ...MaterialCatalog_MaterialBrand
  }
  item {
    ...Named
  }
  defaultVariant {
    id
  }
  materialVariants(includeDeleted: $includeDeleted) {
    ...MaterialCatalog_MaterialListingCardVariant
  }
}
    ${MaterialCatalog_MaterialBrandFragmentDoc}
${NamedFragmentDoc}
${MaterialCatalog_MaterialListingCardVariantFragmentDoc}`;
export const MaterialCatalog_MaterialAttributeValueFragmentDoc = gql`
    fragment MaterialCatalog_MaterialAttributeValue on MaterialAttributeValue {
  id
  textValue
}
    `;
export const MaterialCatalog_MaterialAttributeDimensionFragmentDoc = gql`
    fragment MaterialCatalog_MaterialAttributeDimension on MaterialAttributeDimension {
  id
  name
  isAdminManaged
  useInTakeoff
  sortOrder
  type {
    code
  }
  unitOfMeasure {
    id
    abbreviation
  }
  values {
    ...MaterialCatalog_MaterialAttributeValue
  }
}
    ${MaterialCatalog_MaterialAttributeValueFragmentDoc}`;
export const MaterialCatalog_ItemFragmentDoc = gql`
    fragment MaterialCatalog_Item on Item {
  id
  name
  materialAttributeDimensions {
    ...MaterialCatalog_MaterialAttributeDimension
  }
}
    ${MaterialCatalog_MaterialAttributeDimensionFragmentDoc}`;
export const MaterialCatalog_MaterialListingFragmentDoc = gql`
    fragment MaterialCatalog_MaterialListing on MaterialListing {
  id
  name
  description
  manufacturerUrl
  type {
    code
  }
  brand {
    ...MaterialCatalog_MaterialBrand
  }
  item {
    ...MaterialCatalog_Item
  }
}
    ${MaterialCatalog_MaterialBrandFragmentDoc}
${MaterialCatalog_ItemFragmentDoc}`;
export const MaterialCatalog_AssetFragmentDoc = gql`
    fragment MaterialCatalog_Asset on Asset {
  id
  version
  url
  fileName
  contentType
  downloadUrl
  attachmentUrl
  previewUrl(resizing: {width: 330, region: FULL})
  createdAt
}
    `;
export const MaterialCatalog_MaterialVariantImageFragmentDoc = gql`
    fragment MaterialCatalog_MaterialVariantImage on MaterialVariantImage {
  id
  sortOrder
  asset {
    ...MaterialCatalog_Asset
  }
}
    ${MaterialCatalog_AssetFragmentDoc}`;
export const MaterialCatalog_MaterialVariantFragmentDoc = gql`
    fragment MaterialCatalog_MaterialVariant on MaterialVariant {
  id
  code
  displayName
  codeOverride
  modelNumber
  deletedAt
  defaultBidItem {
    id
  }
  listing {
    ...MaterialCatalog_MaterialListing
  }
  featuredImage {
    ...MaterialCatalog_MaterialVariantImage
  }
}
    ${MaterialCatalog_MaterialListingFragmentDoc}
${MaterialCatalog_MaterialVariantImageFragmentDoc}`;
export const MaterialCatalogListingsDocument = gql`
    query MaterialCatalogListings($filter: MaterialListingsFilter!, $orderBy: MaterialListingOrderBy, $page: PageFilter, $includeDeleted: Boolean!) {
  materialListings(filter: $filter, orderBy: $orderBy, page: $page) {
    entities {
      ...MaterialCatalog_MaterialListingCard
    }
    pageInfo {
      hasNextPage
      totalCount
    }
  }
}
    ${MaterialCatalog_MaterialListingCardFragmentDoc}`;

/**
 * __useMaterialCatalogListingsQuery__
 *
 * To run a query within a React component, call `useMaterialCatalogListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialCatalogListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialCatalogListingsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useMaterialCatalogListingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MaterialCatalogListingsQuery, MaterialCatalogListingsQueryVariables> & ({ variables: MaterialCatalogListingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MaterialCatalogListingsQuery, MaterialCatalogListingsQueryVariables>(MaterialCatalogListingsDocument, options);
      }
export function useMaterialCatalogListingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MaterialCatalogListingsQuery, MaterialCatalogListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MaterialCatalogListingsQuery, MaterialCatalogListingsQueryVariables>(MaterialCatalogListingsDocument, options);
        }
// @ts-ignore
export function useMaterialCatalogListingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MaterialCatalogListingsQuery, MaterialCatalogListingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MaterialCatalogListingsQuery, MaterialCatalogListingsQueryVariables>;
export function useMaterialCatalogListingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialCatalogListingsQuery, MaterialCatalogListingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MaterialCatalogListingsQuery | undefined, MaterialCatalogListingsQueryVariables>;
export function useMaterialCatalogListingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialCatalogListingsQuery, MaterialCatalogListingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MaterialCatalogListingsQuery, MaterialCatalogListingsQueryVariables>(MaterialCatalogListingsDocument, options);
        }
export type MaterialCatalogListingsQueryHookResult = ReturnType<typeof useMaterialCatalogListingsQuery>;
export type MaterialCatalogListingsLazyQueryHookResult = ReturnType<typeof useMaterialCatalogListingsLazyQuery>;
export type MaterialCatalogListingsSuspenseQueryHookResult = ReturnType<typeof useMaterialCatalogListingsSuspenseQuery>;
export type MaterialCatalogListingsQueryResult = ApolloReactCommon.QueryResult<MaterialCatalogListingsQuery, MaterialCatalogListingsQueryVariables>;
export const MaterialCatalogMetadataDocument = gql`
    query MaterialCatalogMetadata {
  materialBrands(filter: {}) {
    ...MaterialCatalog_MaterialBrand
  }
  items(filter: {version: 2}) {
    ...MaterialCatalog_Item
  }
  markets {
    id
    name
  }
  materialVariantTags {
    ...Named
  }
}
    ${MaterialCatalog_MaterialBrandFragmentDoc}
${MaterialCatalog_ItemFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useMaterialCatalogMetadataQuery__
 *
 * To run a query within a React component, call `useMaterialCatalogMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialCatalogMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialCatalogMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useMaterialCatalogMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MaterialCatalogMetadataQuery, MaterialCatalogMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MaterialCatalogMetadataQuery, MaterialCatalogMetadataQueryVariables>(MaterialCatalogMetadataDocument, options);
      }
export function useMaterialCatalogMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MaterialCatalogMetadataQuery, MaterialCatalogMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MaterialCatalogMetadataQuery, MaterialCatalogMetadataQueryVariables>(MaterialCatalogMetadataDocument, options);
        }
// @ts-ignore
export function useMaterialCatalogMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MaterialCatalogMetadataQuery, MaterialCatalogMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MaterialCatalogMetadataQuery, MaterialCatalogMetadataQueryVariables>;
export function useMaterialCatalogMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialCatalogMetadataQuery, MaterialCatalogMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MaterialCatalogMetadataQuery | undefined, MaterialCatalogMetadataQueryVariables>;
export function useMaterialCatalogMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialCatalogMetadataQuery, MaterialCatalogMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MaterialCatalogMetadataQuery, MaterialCatalogMetadataQueryVariables>(MaterialCatalogMetadataDocument, options);
        }
export type MaterialCatalogMetadataQueryHookResult = ReturnType<typeof useMaterialCatalogMetadataQuery>;
export type MaterialCatalogMetadataLazyQueryHookResult = ReturnType<typeof useMaterialCatalogMetadataLazyQuery>;
export type MaterialCatalogMetadataSuspenseQueryHookResult = ReturnType<typeof useMaterialCatalogMetadataSuspenseQuery>;
export type MaterialCatalogMetadataQueryResult = ApolloReactCommon.QueryResult<MaterialCatalogMetadataQuery, MaterialCatalogMetadataQueryVariables>;
export const SaveMaterialVariantDocument = gql`
    mutation SaveMaterialVariant($input: SaveMaterialVariantInput!) {
  saveMaterialVariant(input: $input) {
    materialVariant {
      ...MaterialCatalog_MaterialVariant
      listing {
        id
      }
      components {
        ...MaterialAssemblyForm_AssemblyComponent
      }
    }
  }
}
    ${MaterialCatalog_MaterialVariantFragmentDoc}
${MaterialAssemblyForm_AssemblyComponentFragmentDoc}`;

/**
 * __useSaveMaterialVariantMutation__
 *
 * To run a mutation, you first call `useSaveMaterialVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMaterialVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMaterialVariantMutation, { data, loading, error }] = useSaveMaterialVariantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMaterialVariantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveMaterialVariantMutation, SaveMaterialVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveMaterialVariantMutation, SaveMaterialVariantMutationVariables>(SaveMaterialVariantDocument, options);
      }
export type SaveMaterialVariantMutationHookResult = ReturnType<typeof useSaveMaterialVariantMutation>;
export type SaveMaterialVariantMutationResult = ApolloReactCommon.MutationResult<SaveMaterialVariantMutation>;
export const SaveMavDocument = gql`
    mutation SaveMav($input: SaveMaterialAttributeValueInput!) {
  saveMaterialAttributeValue(input: $input) {
    materialAttributeValue {
      ...MaterialCatalog_MaterialAttributeValue
    }
  }
}
    ${MaterialCatalog_MaterialAttributeValueFragmentDoc}`;

/**
 * __useSaveMavMutation__
 *
 * To run a mutation, you first call `useSaveMavMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMavMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMavMutation, { data, loading, error }] = useSaveMavMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMavMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveMavMutation, SaveMavMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveMavMutation, SaveMavMutationVariables>(SaveMavDocument, options);
      }
export type SaveMavMutationHookResult = ReturnType<typeof useSaveMavMutation>;
export type SaveMavMutationResult = ApolloReactCommon.MutationResult<SaveMavMutation>;
export const SaveMaterialBrandDocument = gql`
    mutation SaveMaterialBrand($input: SaveMaterialBrandInput!) {
  saveMaterialBrand(input: $input) {
    materialBrand {
      ...MaterialCatalog_MaterialBrand
    }
  }
}
    ${MaterialCatalog_MaterialBrandFragmentDoc}`;

/**
 * __useSaveMaterialBrandMutation__
 *
 * To run a mutation, you first call `useSaveMaterialBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMaterialBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMaterialBrandMutation, { data, loading, error }] = useSaveMaterialBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMaterialBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveMaterialBrandMutation, SaveMaterialBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveMaterialBrandMutation, SaveMaterialBrandMutationVariables>(SaveMaterialBrandDocument, options);
      }
export type SaveMaterialBrandMutationHookResult = ReturnType<typeof useSaveMaterialBrandMutation>;
export type SaveMaterialBrandMutationResult = ApolloReactCommon.MutationResult<SaveMaterialBrandMutation>;